export default class Storage {
  static setItem(key, value) {
    try {
      let valueString = JSON.stringify(value);

      localStorage.setItem(key, valueString);
    } catch (error) {
      // do nothing
    }
  }

  static getItem(key, defaultValue = null) {
    try {
      let value = localStorage.getItem(key);

      try {
        value = JSON.parse(value);
      } catch (error) {
        // nothing
      }

      return value || defaultValue;
    } catch (error) {
      return defaultValue;
    }
  }

  static getItemBoolean(key, defaultValue = false) {
    const value = localStorage.getItem(key);

    if (value === null) {
      return defaultValue;
    }

    try {
      return JSON.parse(value);
    } catch (error) {
      return defaultValue;
    }
  }

  static removeItem(key) {
    localStorage.removeItem(key);
  }

  static clear() {
    localStorage.clear();
  }
}
